import React, { useContext, useEffect, useReducer, useMemo } from 'react'

import { Box, IconButton, Tooltip } from '@mui/material'
import { api } from '../../../services/api';
import toast from 'react-hot-toast'
import { getSession } from '../../../contexts/auth';
import { lockedReducer } from '../../Utils/reducers';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { externalComponent } from '../../AppRoutes';
import EditPeopleModal, { ViewPeopleModel } from './Edit-people-model';
import InfoIcon from '@mui/icons-material/Info';
import dayjs from 'dayjs';
import Table, { TableHook } from '../../Table';
import { ResponsiveActionBox } from '../../Table/mobileTable';
import { maskedTable } from '../../Utils/MaskedInput';
import { NumbersOnly } from '../../Utils/IntegerOnly';
import FunctionComponent from '../Scripts/functions';
import HistoryIcon from '@mui/icons-material/History';
import ViewHistoricalPeopleModal from './historic';

const url = '/people/'

const submitDelete = async (data, setState, getData, setLoader) => {
    setLoader(true)
    const res = await api.delete(`${url}${data.id}/`)
    setLoader(false)
    if (res.status === 204) {
        toast.success('Deletado com sucesso')
        setState({ deleteRow: false })
        getData()
        return
    }
    console.error('Falha ao deletar')

}

const columns = (setState, permissions) => {
    return [
        { field: 'name', headerName: 'Nome', flex: 1, filterType: 'string' },
        {
            field: 'cnpj', headerName: 'CNPJ', flex: 1, filterType: 'string', renderCell: ({ value }) =>
                maskedTable.cpfcnpj({ value: value ? NumbersOnly(value) : '' })
        },
        { field: 'phone_numbers', headerName: 'Telefone', flex: 1, filterType: 'string' },
        { field: 'status', headerName: 'Status', flex: 1, filterType: 'string' },
        { field: 'option', headerName: 'Regime', flex: 1, filterType: 'string' },
        {
            field: 'created_at', headerName: 'Data de criação', flex: 1, filterType: 'daterange',
            valueGetter: ({ value }) => dayjs(value).toDate().toLocaleString()
        },
        {
            field: 'ultima_atualizacao', headerName: 'Última atualização', flex: 1, filterType: 'daterange',
            valueGetter: ({ value }) => dayjs(value).toDate().toLocaleString()
        },
        {
            field: 'actions', headerName: 'Ações', filterable: false, width: 200,
            renderCell: (props) => {
                return (
                    <ResponsiveActionBox >
                        {permissions.change_people && <Tooltip title='Editar pessoa'>
                            <IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton>
                        </Tooltip>}
                        {permissions.view_historicalpeople && <Tooltip title='Ver histórico de atualizações'>
                            <IconButton onClick={() => { setState({ viewHistoric: props.row }) }}><HistoryIcon /></IconButton>
                        </Tooltip>}
                        {permissions.view_people && <Tooltip title='Ver dados adicionais'>
                            <IconButton onClick={() => { setState({ viewRow: props.row }) }}><InfoIcon /></IconButton>
                        </Tooltip>}
                        {permissions.delete_people && <Tooltip title='Excluir pessoa'>
                            <IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton>
                        </Tooltip>}
                    </ResponsiveActionBox>
                )
            }
        }
    ]
}

export const loadData = async (setState, permission, setLoader) => {
    if (!permission) {
        toast.error('Você não tem permissão para ver as pessoas')
        return
    }
    const requests = [
        api.get('/permissions/'),
        api.get('/scripts/?remote=True')
    ]
    const [permissions, scripts] = await Promise.all(requests)
    const result = {}
    if (permissions.status === 200)
        result.permissions = permissions.data.results
    if (scripts.status === 200)
        result.scripts = scripts.data.results
    setState({ ...result })
}

const Peoples = () => {

    const { setLoader } = useContext(externalComponent)

    const user = getSession()

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        permissions: [],
        editRow: null,
        deleteRow: null,
        viewRow: null,
        viewHistoric: null,
        scripts: []
    })

    useEffect(() => {
        loadData(setState, user.permissions.view_people, setLoader)
    }, [setLoader, user.permissions.view_people])

    const [table, reloadTable] = TableHook()

    const reloadData = () => {
        loadData(setState, user.permissions.view_people, setLoader)
        reloadTable()
    }

    return (
        <>
            {state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir a pessoa? ${state.deleteRow.name}?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => submitDelete(state.deleteRow, setState, reloadData, setLoader)}
                />
            }
            {state.editRow &&
                <EditPeopleModal
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={reloadData}
                    permissions={state.permissions}
                />
            }
            {state.viewHistoric &&
                <ViewHistoricalPeopleModal
                    data={state.viewHistoric}
                    handleClose={() => setState({ viewHistoric: null })}
                    reloadData={reloadData}
                    permissions={state.permissions}
                />
            }
            {state.viewRow &&
                <ViewPeopleModel
                    data={state.viewRow}
                    handleClose={() => setState({ viewRow: null })}
                />
            }
            <Box className='information-table'>
                <Box className='user-table'>
                    <Table
                        rows={state.rows}
                        columns={useMemo(() => columns(setState, user.permissions), [user.permissions])}
                        pagination
                        density='compact'
                        slots={{
                            returnComponent: () => window.backtobase(),
                            addComponent: user.permissions.add_people ? () => setState({ editRow: {} }) : null,
                            filterComponent: true,
                            importComponent: user.permissions.add_people,
                            exportComponent: user.permissions.add_people,
                            functionComponent: state.scripts.length > 0 ? <FunctionComponent data={state.scripts} /> : null
                        }}
                        toolbar
                        getURL={url}
                        updateRows={(rows) => setState({ 'rows': rows })}
                        innerRef={table}
                        mobile={true}
                        mobileProps={
                            {
                                title: ['name']
                            }
                        }
                    />
                </Box>
            </Box>
        </>
    )
}

export default Peoples